import React from 'react';
import CustomSelect from 'components/CustomSelect';
import { GridCellParams } from '@material-ui/data-grid';
import { Field, FieldProps } from 'formik';
import { Grid, MenuItem } from '@material-ui/core';
import { IMailingRuleParsedToStrategyActionsItem } from 'interfaces/Strategy';

const CustomSelectPriority = (
  params: GridCellParams,
  serviceId: string,
  list: IMailingRuleParsedToStrategyActionsItem[],
  isViewOnly = false,
): JSX.Element => {
  return (
    <Field
      fullWidth
      name={`selectedServiceCategories[${serviceId}][${params.row.id}].priority`}
      disabled={isViewOnly}
    >
      {({ field, form, meta }: FieldProps) => (
        <Grid item xs={12}>
          {isViewOnly
            ? form.values.selectedServiceCategories[serviceId][params.row.id]
                .priority || ''
            : form.values.selectedServiceCategories[serviceId][params.row.id]
                .activation && (
                <CustomSelect
                  field={field}
                  form={form}
                  meta={meta}
                  defaultValue={''}
                >
                  {list
                    .filter(
                      (item) =>
                        form.values.selectedServiceCategories[serviceId][
                          item.id
                        ].activation,
                    )
                    .map(
                      (
                        item: IMailingRuleParsedToStrategyActionsItem,
                        index: number,
                      ) => (
                        <MenuItem key={item.id} value={index + 1}>
                          {index + 1}
                        </MenuItem>
                      ),
                    )}
                </CustomSelect>
              )}
        </Grid>
      )}
    </Field>
  );
};

export default CustomSelectPriority;
